export default {
    nav: {
        home: "главная",
        gallery: "галерея",
        updates: "изменения",
        help: "помощь",
        operation: "эксплуатация",
        contacts: "контакты",
    },
    layout: {
        brand_subtitle: "library software platform",
        cta: "связаться",
        switch_language: "язык",
        image_viewer: {
            title: "Изображение",
        },
        button: {
            close: "Закрыть",
        },
    },
    footer: {
        description: "Профессиональная библиотечная система для автоматизации ключевых процессов современной библиотеки.",
        rights: "все права защищены",
    },
    home: {
        capabilities_title: "ключевые возможности",
        capabilities_text: "Платформа покрывает основные библиотечные процессы и даёт учреждению понятный цифровой контур для ежедневной работы.",
        audience_title: "для каких библиотек подходит",
        cta_updates: "посмотреть изменения",
    },
    gallery: {
        title: "галерея",
        text: "Добро пожаловать в галерею UniLib. Здесь представлены визуальные материалы и примеры интерфейсов системы.",
    },
    updates: {
        title: "последние изменения",
        text: "Ознакомьтесь с последними обновлениями UniLib. Это лишь часть изменений, демонстрирующая активное развитие и «живость» системы.",
    },
    help: {
        title: "помощь",
        text: "Раздел справки перестроен как каталог материалов с отдельными страницами статей.",
        open_article: "открыть статью",
        back: "к разделу справки",
    },
    operation: {
        title: "эксплуатация",
        text: "Здесь собран краткий сценарий внедрения, обновления и поддержки системы.",
    },
    contacts: {
        title: "контакты",
        text:
            "Свяжитесь с нами по любым вопросам, связанным с системой UniLib. " +
            "Мы предоставим необходимую информацию, проконсультируем по возможностям системы и вариантам её внедрения в вашей инфраструктуре. " +
            "Рассматриваем как стандартные сценарии использования, так и задачи с повышенными требованиями и особенностями реализации. ",
    },
    legacy: {
        title: "Сайт обновлён",
        text: "Вы перешли по устаревшему адресу. Структура сайта была обновлена. Пожалуйста, начните работу с главной страницы или свяжитесь с нами для уточнения информации.",
        home: "На главную",
        contact: "Связаться",
    },
} as const;
